<template>
  <material-card class=pt-2 full-header>
    <template #heading>
      <v-toolbar color="accent">
        <v-toolbar-title>
          <v-icon> mdi-book-open-variant </v-icon>
          {{ professor?.firstname + ' '+professor?.lastname }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon dark class="mb-2" @click="close">
          <v-icon medium>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </template>

    <v-data-table :items="courseList" :headers="coursesHeader" :loading="loading" item-key="courseID"
      :search="search"  :page="pageNumber">
      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>
            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line hide-details>
            </v-text-field>
          </v-toolbar-title>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon dark class="mb-2" v-bind="attrs" v-on="on" color="primary" @click="getCourses">
                <v-icon medium>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>
              {{ $t("refresh") }}
            </span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <!-- custom columns -->
     
    </v-data-table>
    <template #actions>

    </template>
  </material-card>
</template>
<script>
export default {
  name: "BBBLiveCourses",
  props: {
    visible: Boolean,
    professor: {
      type: Object,
      default: {}
    }
  },
  computed: {
   
  },
  data() {
    return {

      coursesHeader: [
        { value: "course_id", text: this.$t("course_id") },
        { value: "course_name", text: this.$t("course_name") },
        { value: "total_unit", text: this.$t("total_unit") },
        { value: "theoretical_unit", text: this.$t("theoretical_unit") },
        { value: "practical_unit", text: this.$t("practical_unit") },
        { value: "term", text: this.$t("term") },
        { value: "is_active", text: this.$t("is_active") },
      ],
      courseList: [],
      loading: true,
      totalServers: 0,
      options: {},
      itemPerPage: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 10,
      joinLoading: false,
      search: '',
      expanded: []
    };
  },
  watch: {
   
  },
  methods: {
    getCourses() {
      axios({
        url: process.env.VUE_APP_BACKEND_URL + "/api/e_learning/professors/"+this.professor.id+"/coursesv2",
        method: "GET",
        headers: {
          Authorization: this.$store.get("login/token"),
        },
       
      })
        .then((response) => {
          let data = response.data;
          this.courseList = data
          this.loading = false;
        })
        .catch((error) => {
          console.log('error', error);
        }).finally(() => {
          this.loading = false;
        });
    },
    
    close() {
      this.$emit('close')
    }
  },
  mounted() {
    this.getCourses();
  },
};
</script>
<style>
.text-content-left input {
  text-align: left !important;
}
</style>
  